import { render, staticRenderFns } from "./change-deadline.vue?vue&type=template&id=bbcd0bce&scoped=true&"
import script from "./change-deadline.vue?vue&type=script&lang=js&"
export * from "./change-deadline.vue?vue&type=script&lang=js&"
import style0 from "./change-deadline.vue?vue&type=style&index=0&id=bbcd0bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcd0bce",
  null
  
)

export default component.exports